module.exports = __webpack_public_path__ + "421816cc869d724b530f10e71e2473cb.svg";